import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import Login from '../../component/login/login.js'
import { Link} from "react-router-dom"
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'
import {xxflStaus} from '../../redux/newGame.redux.js'
import './new-game-list.css'
@connect(
  state=>state.chatuser,
  {getBigBGUrl}
)
@connect(
  state=>state.chatuser,
  {userList}
)
@connect(
  state=>state.newGame,
  {xxflStaus}
)
class NewGameList extends React.Component{
	constructor(props){
		super(props)
		this.state={
		
			gameList:null,
			navNum:0
	      		
    	}
    	this.navData = ['全部游戏','端游','手游']
    
    	
	}
	componentDidMount(){
  
    
    	this.handleGameList(0)
  	}
  	handleGameList(ieq){
  		
  		axios.get('/fapi/index/recomgames?page=1&eq='+ieq)
  			.then(res=>{
  				this.setState({
  					gameList:res.data.data,
  					navNum:ieq
  				})
  			})
  		 
  	}
  	handleDetail(id){
  		this.props.history.push('/game-detail/'+id)
  		this.props.xxflStaus(1)	
  	}
  	render(){
  		return(
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')'}}>
				<HeaderBar></HeaderBar>
				<div className="t-new-game-list clearfix">
					<Login showLogin={this.props.showLogin}>
		               
		            </Login>
					
					<div className="list-box">
						<div className="his-from"><Link to="/index">首页</Link> > 游戏推荐</div>
						<div className="new-game-con">
							<nav >
								{
									this.navData.map((item,i)=>(
										<div 
											key={i} 
											onClick={()=>this.handleGameList(i)}
											className={this.state.navNum===i?'active':''}
										>{item}</div>
									))
								}
								
							</nav>
							
							<ul className="clearfix">
								{
									this.state.gameList&&this.state.gameList.map((item,i)=>(
										<li key={i} >
											
					                  			<div className="game-prop-img" style={{backgroundImage:"url("+(item.imgurl)+")"}}></div>
					                  			<span className={
					                  					item.type===1?'game-prop-name active2':
					                  						item.type===2?'game-prop-name active':
					                  							'game-prop-name'
					                  				  }
					                  			>{item.gamename}</span>
						                     	 <em>{item.number}人领取福利</em>
						                      
												<a href="javascript:;" onClick={()=>this.handleDetail(item.game_id)}></a>
						                       	
						                    
						                        
						                    

										</li>
									))
								}
								

							</ul>
						
						</div>
					</div>
				</div>
			</div>
  		)
  	}
	
}

export default NewGameList



// WEBPACK FOOTER //
// ./src/container/new-game-list/new-game-list.js